<template>

<div class="row">
    <div class="flex xs12 md4">

        <va-card title="Perguntas">
            <div v-for="(professor, index) in perguntas" :key="index">

             <div class="va-item align--center no-wrap va-item--clickable" @click="launchToast(professor, index)">
                <div class="va-item-section va-item-section--avatar">
                    <div class="va-avatar">
                        <img src="https://randomuser.me/api/portraits/women/1.jpg">
                    </div>
                </div>
                <div class="va-item-section va-item-section--main">
                    <div class="va-item-label ellipsis">
                        {{ professor.nome }}
                    </div>
                    <div class="va-item-label ellipsis va-item-label--caption">
                        {{ professor.pergunta }}
                    </div>
                </div>

                <div class="va-item-section va-item-section--side">
                    <i class="va-icon fa fa-eye" style="color: rgb(186, 191, 194);"></i>
                </div>
            </div>
                  <div>
                      <div class="va-list-separator va-list-separator--offset"></div>
                </div>
            </div>
        </va-card>

    </div>

    <div class="flex xs12 md8 ">

        <va-card>
                    
            
                <chatrespostas v-model="perguntas"/>
            

        </va-card>
          
    </div>

</div>
</template>

<script>

import chatrespostas from './chatRespostas'

export default {
  name: 'forum-page',
  components: { chatrespostas },
  data () {
    return {
      toastText: 'Sucesso',
      toastDuration: 2500,
      toastIcon: 'fa-star-o',
      toastPosition: 'bottom-right',

      aceito: false,

      prof : {},

      perguntas: [
        {
          nome: 'teste',  
          pergunta: 'Hello! So glad you liked my work. Do you want me to shoot you?',
          resposta: 'cjbhzjdbflkjsbdkjbfksjdnkjfnsj',
          yours: false,
        },
        {
          nome: 'teste2',  
          pergunta: 'Yeah, that would be cool. Maybe this Sunday at 3 pm?',
          resposta: 'cjbhzjdbflkjsbdkjbfksjdnkjfnsj',
          yours: true,
        },
        {
          nome: 'teste3',  
          pergunta: 'Sounds great! See you later!',
          resposta: 'cjbhzjdbflkjsbdkjbfksjdnkjfnsj',
          yours: false,
        },
        
      ],
    }
  },
  computed: {
    isToastContentPresent () {
      return !!(this.toastText || this.toastIcon)
    },
  },
  methods: {
    launchToast (pergun, index) {
      this.showToast(
        this.toastText,
        {
          icon: this.toastIcon,
          position: this.toastPosition,
          duration: this.toastDuration
        },
      )



    },

    salvarResposta () {

    }
  }
}
</script>

<style lang='scss'>
   
</style>
